import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthSessionProvider } from '@ekhodealer/ekho-common/auth-client';

import { auth } from '@config/firebase';
import { apiClient } from '@config/server/apiClient';
import { queryClient } from '@config/server/queryClient';
import { queries } from '@config/server/queryKeys';

interface AuthSessionWrapperProps {
	children: React.ReactNode;
}

/**
 * AuthSessionWrapper
 * Wraps AuthSessionProvider with dependency injection props.
 * Uses useNavigate hook to handle 401 redirects (can't use hooks in router definition).
 */
export function AuthSessionWrapper({ children }: AuthSessionWrapperProps) {
	const navigate = useNavigate();

	const handleUnauthorized = useCallback(() => {
		navigate('/login', { replace: true });
	}, [navigate]);

	return (
		<AuthSessionProvider
			auth={auth}
			apiClient={apiClient}
			queryClient={queryClient}
			queryKeys={{
				me: queries.auth.me.queryKey,
				debug: queries.auth.debug.queryKey,
			}}
			meEndpoint="/admin_portal/auth/me"
			onUnauthorized={handleUnauthorized}
		>
			{children}
		</AuthSessionProvider>
	);
}
